import type { FunctionComponent } from "react";

import type { DocumentRequestResponse } from "~/v2/api/rest/account";
import { useRequestedDocumentUpload } from "./RequestedDocumentUpload.controller";
import { RequestedDocumentUploadPres } from "./RequestedDocumentUpload.pres";

interface RequestedDocumentUploadProps {
  isLegalEntity: boolean;
  documentRequest: DocumentRequestResponse;
}

export const RequestedDocumentUpload: FunctionComponent<
  RequestedDocumentUploadProps
> = ({ isLegalEntity, documentRequest }) => {
  const controllerProps = useRequestedDocumentUpload(
    isLegalEntity,
    documentRequest,
  );

  return (
    <RequestedDocumentUploadPres
      documentRequest={documentRequest}
      {...controllerProps}
    />
  );
};
